export default __webpack_public_path__ + "static/media/gender_oxo.fef4e97b.png";